module.exports = __webpack_public_path__ + "static/media/icon-small-bar.d5f810cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/sass/icons/icon-small-bar.svg
// module id = 308
// module chunks = 0